<template>
  <form @submit.prevent="save()" class="ui small form">
    <h3 class="ui header">Configurações de Contrato</h3>
    <h4 class="ui dividing header">Ativação</h4>
    <div class="field">
      <label>Tipo de ativação</label>
      <div class="inline fields">
        <div class="inline field">
          <div class="ui checkbox">
            <input
              type="radio"
              id="contract-manual-enable-setting"
              value="manual"
              v-model="form.contract_enable_method"
            />
            <label for="contract-manual-enable-setting">
              Ativar contrato manualmente?
            </label>
          </div>
        </div>
        <div class="inline field">
          <div class="ui checkbox">
            <input
              type="radio"
              id="contract-enable-on-payment-setting"
              value="payment"
              v-model="form.contract_enable_method"
            />
            <label for="contract-enable-on-payment-setting">
              Ativar contrato somente após o primeiro pagamento?
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="field">
      <label>Outras</label>
      <div class="inline field">
        <div class="ui checkbox">
          <input
            type="checkbox"
            id="contract-allows-enable-canceled-contract-setting"
            v-model="form.contract_allows_enable_canceled_contract"
          />
          <label for="contract-allows-enable-canceled-contract-setting">
            Permitir ativar contrato cancelado?
          </label>
        </div>
      </div>
    </div>
    <h4 class="ui dividing header">Inadimplência</h4>
    <div class="inline field">
      <label for="contract-days-late-to-overdue-setting">
        Tornar contrato inadimplente após N dias de atraso
      </label>
      <input
        type="text"
        v-model="form.contract_days_late_to_overdue"
        id="contract-days-late-to-overdue-setting"
      />
    </div>
    <h4 class="ui dividing header">Cancelamento</h4>
    <div class="inline field">
      <label for="contract-days-late-to-cancel-setting">
        Cancelar automaticamente após N dias de atraso
      </label>
      <input
        type="text"
        v-model="form.contract_days_late_to_cancel"
        id="contract-days-late-to-cancel-setting"
      />
    </div>
    <h4 class="ui dividing header">Parcelas</h4>
    <div class="inline field">
      <label for="contract-generate-invoices">
        Gerar N parcelas após criar contrato
      </label>
      <input
        type="text"
        v-model="form.contract_generate_invoices"
        id="contract-generate-invoices"
      />
    </div>
    <h4 class="ui dividing header">Faturamento</h4>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="contract-allows-boleto-setting"
          v-model="form.contract_allows_boleto"
        />
        <label for="contract-allows-boleto-setting">
          Permitir pagamento via boleto?
        </label>
      </div>
    </div>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="contract-automatic-payment-by-card"
          v-model="form.contract_automatic_payment_by_card"
        />
        <label for="contract-automatic-payment-by-card">
          Pagar automaticamente quando houver cartão de crédito cadastrado?
        </label>
      </div>
    </div>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="contract-allows-credit-card-setting"
          v-model="form.contract_allows_credit_card"
        />
        <label for="contract-allows-credit-card-setting">
          Permitir pagamento via cartão de crédito?
        </label>
      </div>
    </div>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="contract-allows-manual-credit-card-setting"
          v-model="form.contract_allows_manual_credit_card"
        />
        <label for="contract-allows-manual-credit-card-setting">
          Permitir cadastro de cartão de crédito no contrato?
        </label>
      </div>
    </div>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="contract-show-checkout-link"
          v-model="form.contract_show_checkout_link"
        />
        <label for="contract-show-checkout-link">
          Exibir link para checkout quando disponível?
        </label>
      </div>
    </div>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="contract-request-payment-after-update-payment-method"
          v-model="form.contract_request_payment_after_update_payment_method"
        />
        <label for="contract-request-payment-after-update-payment-method">
          Requisitar pagamento após atualizar cartão de crédito?
        </label>
      </div>
    </div>
    <h4 class="ui dividing header">
      Notificação via e-mail para Cadastro de Cartão de Crédito
    </h4>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="contract-send-credit-card-notification-setting"
          v-model="form.contract_send_credit_card_notification"
        />
        <label for="contract-send-credit-card-notification-setting">
          Enviar notificação para cadastro de cartão de crédito?
        </label>
      </div>
    </div>
    <div class="ui message">
      <p>
        Caso a forma de pagamento seja <b>cartão de crédito</b> e não houver um
        cartão de crédito cadastrado no contrato, uma notificação com o link
        para cadastro de cartão de crédito será enviada para o titular do
        contrato.
      </p>
    </div>
    <div class="field">
      <label for="contract-credit-card-notification-title-setting">
        Título
      </label>
      <input
        type="text"
        v-model="form.contract_credit_card_notification_title"
        id="contract-credit-card-notification-title-setting"
      />
    </div>
    <div class="fields">
      <div class="twelve wide field">
        <label for="contract-credit-card-notification-body-setting">
          Mensagem
        </label>
        <textarea
          v-model="form.contract_credit_card_notification_body"
          id="contract-credit-card-notification-body-setting"
          rows="8"
          cols="80"
        >
        </textarea>
      </div>
      <div class="four wide field">
        <label for="">Opções</label>
        <div>[nome_do_titular]</div>
        <div>[link]</div>
        <div>[codigo_do_contrato]</div>
        <div>[valor_da_parcela]</div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      form: {
        contract_enable_method: null,
        contract_days_late_to_cancel: null,
        contract_days_late_to_overdue: null,
        contract_allows_boleto: null,
        contract_allows_credit_card: null,
        contract_send_credit_card_notification: null,
        contract_credit_card_notification_title: null,
        contract_credit_card_notification_body: null,
        contract_generate_invoices: null,
        contract_automatic_payment_by_card: null,
        contract_allows_manual_credit_card: null,
        contract_show_checkout_link: null,
        contract_allows_enable_canceled_contract: null,
        contract_request_payment_after_update_payment_method: null
      }
    };
  },

  methods: {
    setForm(settings) {
      const formKeys = Object.keys(this.form);
      settings.forEach(setting => {
        if (formKeys.includes(setting.key)) {
          let response = setting.response;
          if (response == 'f') {
            response = false;
          }
          if (response == 't') {
            response = true;
          }
          this.form[setting.key] = response;
        }
      });
    },

    getSettings() {
      return this.form;
    }
  }
};
</script>
